import React from "react";

export default function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Non, quos eligendi. Cumque, doloribus! Voluptates nulla
        quos rerum ab est repudiandae veniam consectetur quisquam fuga deleniti accusamus, molestiae expedita. Labore
        suscipit eveniet, quam, iste error ea tempora et hic neque similique doloribus explicabo odit minus fugiat,
        molestias placeat nemo. Totam, perspiciatis.
      </p>
    </section>
  );
}
